import { cn } from '@shared/utils';

interface ErrorMessageProps {
  className?: string;
  text?: string;
}

export const ErrorMessage = (props: ErrorMessageProps) => {
  if (!props.text) return null;
  return <div className={cn('text-xs text-[#e42d34]', props.className)}>* {props.text}</div>;
};
